
export const PolicyType = {
    termsAndConditions: "terms_and_conditions",
    privacyPolicy: "privacy_policy",
    termsAndPrivacy: "terms_and_privacy"
};
